import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RenovateService } from '../services/renovate.service';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Utils } from '../utils/utils';

@Injectable()
export class RenovateInterceptor implements HttpInterceptor {

  constructor(private _renovateService: RenovateService) { }

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const mustRenovate = req.headers.has("Must-Renovate");
    const hasAccessToken = Utils.getCookie('accessToken');

    if (!hasAccessToken) {
      return  throwError(()=> new HttpErrorResponse({
        status: 401
      }));
    }

    if (!mustRenovate) {
      return next.handle(req);
    }

    req = req.clone({ headers: req.headers.delete("Must-Renovate") });
    return this._renovateService.ensureToken().pipe(
      switchMap((token) => {
        if (token) {
          Utils.setCookie("accessToken", token);

          req = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          });
        }

        return next.handle(req).pipe(
          catchError((error) => {
            return throwError(()=> error);
          }),
        );
      }),
    );
  }
}
